import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  Button,
  Dropdown,
} from "react-bootstrap";
import { FiPlus, FiDownload } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BsGrid, BsList } from "react-icons/bs";
import AddEmployeeModal from "../../../components/modals/hrm/employee/AddEmployeeModal";
import EmployeeStats from "../../../components/hrm/employees/EmployeeStats";
import PlanList from "../../../components/hrm/employees/PlanList";

export default function EmployeesListPage() {
  const [showModal, setShowModal] = useState(false);

  const location = useLocation();
  // ✅ default LIST view
  const [view, setView] = useState("list");

  return (
    <Container
      style={{ padding: "15px", background: "#f8f9fa", height: "100vh" }}
      fluid
      className="p-3 min-vh-100"
    >
      {/* HEADER */}
      <Row className="align-items-center justify-content-between mb-3">
        <Col md={4} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
              Employees List
            </h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <Link to="/">
                  <RiHome6Line
                    className="m text-dark"
                    style={{
                      fontSize: "1.2rem", // increased icon size
                      verticalAlign: "middle",
                    }}
                  />
                </Link>
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Employee
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">Employees List</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>

        <Col md="auto" className="d-flex flex-wrap align-items-center gap-2">
          {/* ICON SWITCH */}

          <div className="d-flex border rounded bg-white p-1">
            {/* LIST BUTTON */}
            <Link to="/employee-lists">
              <Button
                size="sm"
                className={`me-1 ${
                  location.pathname === "/employee-lists"
                    ? "active-view"
                    : "bg-light"
                }`}
              >
                <BsList color="black" />
              </Button>
            </Link>

            {/* GRID BUTTON */}
            <Link to="/employee-grid">
              <Button
                size="sm"
                className={`${
                  location.pathname === "/employee-grid"
                    ? "active-view"
                    : "bg-light"
                }`}
              >
                <BsGrid color="black" />
              </Button>
            </Link>
          </div>

          {/* EXPORT */}
          <Dropdown>
            <Dropdown.Toggle variant="white" className="border">
              <FiDownload className="me-1" /> Export
            </Dropdown.Toggle>

            <Dropdown.Menu align="end">
              <Dropdown.Item>Export as PDF</Dropdown.Item>
              <Dropdown.Item>Export as Excel</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* ADD EMPLOYEE */}
          <Button
            className="d-flex align-items-center"
            onClick={() => setShowModal(true)}
          >
            <FiPlus className="me-2 text-white" />
            Add Employee
          </Button>
        </Col>

        <style>
          {`
          /* orange theme */
          .btn-primary {
            background-color: #f26522 !important;
            border: none;
          }

          .btn-primary:hover {
            background-color: #e5531d !important;
          }

          /* dropdown highlight */
          select:focus {
            border-color: #f26522 !important;
            box-shadow: 0 0 0 0.2rem rgba(242, 101, 34, 0.25);
          }

          /* modal spacing */
          .modal-content {
            border-radius: 10px;
          }
            .active-view {
  background-color: #f26522 !important;
  border: none !important;
}

.active-view svg {
  color: black !important;
  background-color: #f26522 !important;

}

.btn.bg-light {
  background-color: #f37311 !important;
  border: none;
}
  .active-view {
  background-color: #f26522 !important;
  border: none !important;
}

.active-view svg {
  color: #ffffff!important;
  background-color: #f26522 !important;

}

.btn.bg-light {
  background-color: #f8f9fa !important;
  border: none;
}

.btn svg {
  color: black; /* always black icons */
  
}

          /* responsive fix */
          @media (max-width: 768px) {
            .modal-xl {
              max-width: 95%;
            }
          }
          `}
        </style>
      </Row>
      <EmployeeStats />
      <PlanList className="mt-3" />

      {/* 👉 VIEW CONTENT (optional render if you want later) */}
      {view === "list" ? (
        <div> {/* LIST VIEW CONTENT HERE */} </div>
      ) : (
        <div> {/* GRID VIEW CONTENT HERE */} </div>
      )}

      {/* MODAL */}
      <AddEmployeeModal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </Container>
  );
}
